import { useState } from 'react';

interface DeleteTemplateModalProps {
  templateName: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteTemplateModal({ templateName, isOpen, onClose, onConfirm }: DeleteTemplateModalProps) {
  const [confirmText, setConfirmText] = useState('');

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative bg-white rounded-xl w-full max-w-md mx-4">
        <div className="p-5 text-center">
          <div className="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-3">
            <i className="ri-delete-bin-line text-red-500 text-xl" />
          </div>
          <h3 className="text-lg font-semibold text-foreground-950 mb-1">Excluir template</h3>
          <p className="text-sm text-foreground-500 mb-4">
            Tem certeza que deseja excluir <strong className="text-foreground-700">{templateName}</strong>? Esta ação não pode ser desfeita.
          </p>
          <p className="text-xs text-foreground-500 mb-3">
            Digite <strong className="text-foreground-700">excluir</strong> para confirmar
          </p>
          <input
            type="text"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            className="w-full px-3 py-2 bg-white border border-background-200 rounded-lg text-sm text-foreground-900 outline-none focus:border-red-400 focus:ring-2 focus:ring-red-100 transition-all mb-5"
            placeholder="Digite excluir"
          />
          <div className="flex gap-3 justify-center">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-foreground-600 hover:bg-background-100 rounded-lg transition-colors cursor-pointer"
            >
              Cancelar
            </button>
            <button
              onClick={onConfirm}
              disabled={confirmText.trim().toLowerCase() !== 'excluir'}
              className="px-4 py-2 bg-red-500 hover:bg-red-600 disabled:bg-red-300 text-white rounded-lg text-sm font-semibold transition-colors cursor-pointer"
            >
              Excluir template
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}